_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[106],{

/***/ "+lhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 78 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/profile-info/newsletter-subscription/NewsletterSubscription.utils.js
var NewsletterSubscription_utils = __webpack_require__("p9RO");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/client/views/newsletter/Newsletter.queries.js
var Newsletter_queries = __webpack_require__("Jkce");

// EXTERNAL MODULE: ./src/client/views/newsletter/newsletterActions.js
var newsletterActions = __webpack_require__("TnNS");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-errors/FormErrors.jsx
var FormErrors = __webpack_require__("8miM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 13 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/widgets/newsletter-form/NewsletterForm.jsx
var NewsletterForm = __webpack_require__("9KBE");

// CONCATENATED MODULE: ./src/client/views/newsletter/subscription/SubscriptionView.jsx




















var __jsx = react_default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






























var SubscriptionView_SubscribeView = function SubscribeView() {
  var _data$legalInformatio2;

  var _useState = Object(react["useState"])([]),
      submitErrors = _useState[0],
      setSubmitErrors = _useState[1];

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var _router$query = router.query,
      subscriptionId = _router$query.subscriptionId,
      locale = _router$query.locale;
  var shouldDisplaySubscriptionView = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('newsletter.displaySubscriptionView');
  Object(react["useEffect"])(function () {
    if (!shouldDisplaySubscriptionView && !!router) {
      var link = '/_error?statusCode=404';
      var url = locale ? new URI_default.a(link).addQuery({
        locale: locale
      }).toString() : link;
      router.push(url);
    }
  }, [router, shouldDisplaySubscriptionView, locale]);

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: Newsletter_queries["c" /* subscribeQuery */],
    queryOptions: {
      requestName: requestDictionary["rc" /* NEWSLETTER_SUBSCRIPTION_VIEW_RESOLVER */]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var origin = true ? window.location.origin : undefined;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (isLoading) {
    return __jsx("div", {
      className: "fixed inset-0 z-5 flex h-full w-full flex-col items-center justify-center bg-white"
    }, __jsx(Spinner["a" /* Spinner */], {
      iconName: icons["a" /* ICONS */].TRIDENT1
    }));
  }

  Object(i18n["a" /* addTranslationKeys */])(data === null || data === void 0 ? void 0 : data.config);

  var newsletterInitialValues = _objectSpread(_objectSpread({}, ((data === null || data === void 0 ? void 0 : data.newsletters) || []).reduce(function (newslettersCheckbox, newsletter) {
    newslettersCheckbox[newsletter.id] = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('newsletter.preCheckedNewsletterPopin');
    return newslettersCheckbox;
  }, {})), locale === 'ru-RU' ? {
    legalAgreement: false
  } : {});

  var onSubmit = /*#__PURE__*/function () {
    var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values) {
      var _response$subscriptio, _response$subscriptio2;

      var formattedValues, response, error, res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formattedValues = Object(newsletterActions["a" /* formatDataForSubscription */])(_objectSpread(_objectSpread({}, values), {}, {
                originCode: origin === booking_constants["o" /* ORIGIN_PLE */] ? booking_constants["t" /* SUBSCRIPTION_ORIGIN */].CUSTOMER_ACCOUNT : booking_constants["t" /* SUBSCRIPTION_ORIGIN */].NEWSLETTER
              }));

              if (isEmpty_default()(formattedValues.unicodeFirstName)) {
                formattedValues.unicodeFirstName = formattedValues.firstName;
              }

              if (isEmpty_default()(formattedValues.unicodeLastName)) {
                formattedValues.unicodeLastName = formattedValues.lastName;
              }

              _context.next = 5;
              return Object(newsletterActions["b" /* submitSubscriptionForm */])({
                appContext: appContext,
                data: formattedValues,
                isSubscription: true,
                subscriptionId: subscriptionId
              });

            case 5:
              response = _context.sent;
              error = (response === null || response === void 0 ? void 0 : (_response$subscriptio = response.subscription) === null || _response$subscriptio === void 0 ? void 0 : (_response$subscriptio2 = _response$subscriptio.error) === null || _response$subscriptio2 === void 0 ? void 0 : _response$subscriptio2.errorDescription) || [];

              if (isEmpty_default()(error)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", setSubmitErrors([error]));

            case 9:
              trackClickEvent(tracking_constants["F" /* TRACK_EVENT_NAMES */].CLICK_NEWSLETTER, {
                detail_click: 'save_infos'
              });
              res = router.push(Object(i18n["h" /* t */])('newsletter.confirmation.href'));
              return _context.abrupt("return", res);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var displayPhoneInput = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('newsletter.displayPhoneInput');
  var displayEmailInput = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('newsletter.displayEmailInput');

  var _ref2 = (data === null || data === void 0 ? void 0 : data.legalInformations) || {},
      bookingProcess = _ref2.bookingProcess;

  var cgu2 = bookingProcess === null || bookingProcess === void 0 ? void 0 : bookingProcess.find(function (_ref3) {
    var id = _ref3.id;
    return id === 'CGU_2';
  });
  return __jsx(react["Fragment"], null, __jsx(head_default.a, null, __jsx("title", {
    key: "title"
  }, Object(i18n["h" /* t */])('newsletter.seo.title'))), __jsx(TrackPage["a" /* TrackPage */], {
    pageName: tracking_constants["H" /* TRACK_PAGE_NAMES */].CA_NEWSLETTER
  }), __jsx("header", {
    className: "Line Line-Immersive",
    role: "banner"
  }, __jsx(Hero["a" /* Hero */], {
    size: "small",
    title: Object(i18n["h" /* t */])('newsletter.immersiveText.0'),
    url: Object(i18n["h" /* t */])('newsletter.immersiveBackground')
  })), __jsx("main", {
    className: "Line",
    role: "main"
  }, __jsx(SiteContainer["a" /* SiteContainer */], {
    size: "medium"
  }, __jsx("div", {
    className: "md:flex"
  }, __jsx(Title["a" /* Title */], {
    className: "md:w-2/5",
    iconName: icons["a" /* ICONS */].MAIL,
    theme: "title-brand-n1"
  }, Object(i18n["h" /* t */])('newsletter.link.label')), __jsx(Text["a" /* Text */], {
    className: "md:w-3/5",
    text: Object(i18n["h" /* t */])('newsletter.signup.description')
  })), __jsx(formik_esm["d" /* Formik */], {
    initialValues: _objectSpread(_objectSpread({}, newsletterInitialValues), {}, {
      civility: 'M'
    }),
    onSubmit: onSubmit,
    validationSchema: Object(NewsletterForm["b" /* subscriptionSchema */])(displayEmailInput, displayPhoneInput, appContext.locale)
  }, function (_ref4) {
    var _find, _data$legalInformatio;

    var setFieldValue = _ref4.setFieldValue,
        isValid = _ref4.isValid,
        touched = _ref4.touched,
        values = _ref4.values,
        errors = _ref4.errors;
    return __jsx(formik_esm["c" /* Form */], {
      className: "mt-20"
    }, __jsx("div", {
      className: "md:flex"
    }, __jsx("legend", {
      className: "mb-20 text-16 font-bold text-black md:w-2/5"
    }, Object(i18n["h" /* t */])('newsletter.signup.personalInformation')), __jsx("div", {
      className: "md:w-3/5"
    }, __jsx(NewsletterForm["a" /* NewsletterForm */], null))), __jsx("hr", {
      className: "my-40 border-t-1 border-lightGrey"
    }), __jsx("div", {
      className: "md:flex"
    }, __jsx("legend", {
      className: "mb-20 text-16 font-bold text-black md:w-2/5"
    }, Object(i18n["h" /* t */])('newsletter.signup.subscriptions')), __jsx("div", {
      className: "flex flex-col gap-15 md:w-3/5"
    }, ((data === null || data === void 0 ? void 0 : data.newsletters) || []).map(function (checkbox) {
      return __jsx(FormikInput["a" /* FormikInput */], {
        key: checkbox.id,
        label: checkbox.description,
        name: checkbox.id,
        onChange: function onChange(e) {
          return Object(NewsletterSubscription_utils["a" /* onCheckboxChange */])(e.target, setFieldValue);
        },
        type: "checkbox",
        value: checkbox.id
      });
    }), ['en-CN', 'zh-CN'].includes(appContext.locale) && __jsx("div", null, __jsx(FormikInput["a" /* FormikInput */], {
      label: __jsx(Text["a" /* Text */], {
        text: (_find = ((data === null || data === void 0 ? void 0 : (_data$legalInformatio = data.legalInformations) === null || _data$legalInformatio === void 0 ? void 0 : _data$legalInformatio.newsletter) || []).find(function (_ref5) {
          var id = _ref5.id;
          return id === 'PRIVACY_POLICY';
        })) === null || _find === void 0 ? void 0 : _find.label
      }),
      name: "privacyPolicyAggreement",
      type: "checkbox"
    }), touched.privacyPolicyAggreement && !values.privacyPolicyAggreement && __jsx(FormFeedback["a" /* FormFeedback */], {
      isError: true,
      key: "d",
      message: Object(i18n["h" /* t */])('newsletter.errorMessages.privacyPolicyNotAccepted')
    })), appContext.locale === 'ru-RU' && cgu2 && __jsx("div", null, __jsx(FormikInput["a" /* FormikInput */], {
      label: __jsx("div", null, __jsx(Text["a" /* Text */], {
        text: cgu2.description
      }), __jsx("a", {
        className: "text-blue ml-5 underline",
        href: cgu2.url,
        rel: "noopener noreferrer",
        target: "_blank"
      }, cgu2.urlLabel)),
      name: "legalAgreement",
      type: "checkbox"
    }), (touched === null || touched === void 0 ? void 0 : touched.legalAgreement) && (errors === null || errors === void 0 ? void 0 : errors.legalAgreement) && __jsx(FormFeedback["a" /* FormFeedback */], {
      isError: true,
      key: "legalAgreement-feedback",
      message: Object(i18n["h" /* t */])('booking.participants.errorMessage.legalAgreement')
    })))), __jsx("div", {
      className: "my-40 flex-col items-end md:flex"
    }, !isEmpty_default()(submitErrors) && __jsx(FormErrors["a" /* FormErrors */], {
      texts: submitErrors
    }), __jsx(Button["a" /* Button */], {
      className: "w-full md:w-auto",
      iconRight: {
        name: icons["a" /* ICONS */].ARROW_RIGHT
      },
      isDisabled: !isValid || !values.CLUBMED || ['en-CN', 'zh-CN'].includes(appContext.locale) && !values.privacyPolicyAggreement,
      size: "large",
      type: "submit"
    }, Object(i18n["h" /* t */])('newsletter.signup.confirm'))));
  }), ((data === null || data === void 0 ? void 0 : (_data$legalInformatio2 = data.legalInformations) === null || _data$legalInformatio2 === void 0 ? void 0 : _data$legalInformatio2.newsletter) || []).map(function (info) {
    return !isEmpty_default()(info.description) && __jsx(Text["a" /* Text */], {
      className: "text-darkGrey",
      key: info.id,
      text: info.description,
      theme: "text-sans-n2"
    });
  }))));
};
SubscriptionView_SubscribeView.pageId = constants["k" /* NEWSLETTER_SUBSCRIPTION_PAGE_ID */];
SubscriptionView_SubscribeView.pageType = tracking_constants["C" /* STATIC_PAGE_TYPES */].SHOPPING_NEWSLETTER;
// CONCATENATED MODULE: ./pages/newsletter/s.js

/* harmony default export */ var s = __webpack_exports__["default"] = (SubscriptionView_SubscribeView);

/***/ }),

/***/ "8miM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormErrors; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DwNm");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;


var FormErrors = function FormErrors(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      _ref$texts = _ref.texts,
      texts = _ref$texts === void 0 ? [] : _ref$texts;
  return __jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, texts.map(function (text) {
    return __jsx(_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__[/* FormFeedback */ "a"], {
      key: text,
      isError: true,
      message: text
    });
  }));
};

/***/ }),

/***/ "9KBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterForm; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("L7OA");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("/HC4");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var subscriptionSchema = function subscriptionSchema(displayEmailInput, displayPhoneInput, locale) {
  return function () {
    return yup__WEBPACK_IMPORTED_MODULE_1__["object"]().shape({
      civility: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      firstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(20, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.fieldTooLong', {
        label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
        maxlength: 20
      })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      lastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(30, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.fieldTooLong', {
        label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
        maxlength: 30
      })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      unicodeFirstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
      unicodeLastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
      email: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().when([], {
        is: function is() {
          return displayEmailInput;
        },
        then: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().nullable().when('phone', {
          is: function is(phone) {
            return !phone;
          },
          then: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().email(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.invalidEmailField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
          otherwise: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().notRequired()
        })
      }),
      phone: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().nullable().when([], {
        is: function is() {
          return displayPhoneInput;
        },
        then: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().when('email', {
          is: function is(email) {
            return !email;
          },
          then: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
          otherwise: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().notRequired()
        })
      }),
      // add conditional validation if legalAgreement is locale is russian
      legalAgreement: locale === 'ru-RU' ? yup__WEBPACK_IMPORTED_MODULE_1__["boolean"]().oneOf([true], Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.errorMessage.legalAgreement')) : yup__WEBPACK_IMPORTED_MODULE_1__["boolean"]().notRequired().nullable()
    });
  };
};
var NewsletterForm = function NewsletterForm() {
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* useAppContext */ "c"])();
  var locale = appContext.locale;

  var _useMemo = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return [Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayPhoneInput') && {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.mobileNumber'),
      name: 'phone',
      type: 'tel'
    }, Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayEmailInput') && {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.email'),
      name: 'email',
      placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.inputFormats.email'),
      type: 'email'
    }];
  }, [locale]),
      phoneInputProps = _useMemo[0],
      emailInputProps = _useMemo[1];

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx("div", {
    className: "-mx-10 md:flex"
  }, __jsx("div", {
    className: "w-full px-10 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.civility'),
    name: "civility",
    options: [{
      isDisabled: true,
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.civility'),
      value: ''
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.civilityMale'),
      value: 'M'
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.civilityFemale'),
      value: 'F'
    }],
    type: "select"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
    name: "firstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
    type: "text"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
    name: "lastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
    type: "text"
  }))), appContext.displayUnicodeFields && Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayUnicodeFields') && __jsx("div", {
    className: "-mx-10 mt-15 md:flex"
  }, __jsx("div", {
    className: "w-full px-10 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeFirstName'),
    name: "unicodeFirstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeFirstName'),
    type: "text"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeLastName'),
    name: "unicodeLastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeLastName'),
    type: "text"
  }))), phoneInputProps && __jsx("div", {
    className: "mt-15"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], phoneInputProps)), emailInputProps && __jsx("div", {
    className: "mt-15"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], emailInputProps)));
};

/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex font-bold gap-10 items-center leading-1 my-10 text-14', "".concat(isError ? 'text-red' : 'text-success'), className),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('shrink-0', {
      'pt-5 px-5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "Jkce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subscribeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unsubscribeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSubscriptionQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmationSubcriptionQuery; });
var subscribeQuery = "\nquery {\n  legalInformations {\n    newsletter {\n      id\n      label\n      description\n      url\n      required\n      preChecked\n    }\n    bookingProcess {\n      id\n      ref\n      url\n      title\n      label\n      urlLabel\n      description\n      required\n      preChecked\n      concernedAttendees\n      type\n    }\n  }\n  newsletters { description id }\n  config {\n    booking {\n      participants {\n        labels {\n          civility\n          email\n          firstName\n          lastName\n        }\n        errorMessage {\n          legalAgreement\n        }\n      }\n    }\n    common {\n      form {\n        errors {\n          requiredField\n          validField\n          fieldTooLong\n        }\n      }\n    }\n    newsletter {\n      errorMessages {\n        privacyPolicyNotAccepted\n      }\n      immersiveText\n      immersiveBackground\n      seo { title description }\n      signup {\n        civilityFemale\n        civilityMale\n        confirm\n        description\n        subscriptions\n        mobileNumber\n      }\n      link { label href }\n      confirmation : confirmation {\n        href\n      }\n    }\n  }\n}\n";
var unsubscribeQuery = "\n  query {\n    legalInformations {\n      newsletter {\n        description\n        id\n        label\n        preChecked\n        required\n        url\n      }\n    }\n    newsletters { description id }\n    config {\n      newsletter {\n        immersiveText\n        immersiveBackground\n        seo { description title }\n        signup { confirm subscriptions }\n        management { description label }\n        link { href label }\n        confirmationUnsubscription : managementConfirmation { href }\n        confirmationSubscription : confirmation { href }\n      }\n    }\n  }\n";
var getSubscriptionQuery = function getSubscriptionQuery(subscriptionId) {
  return "query {\n  subscriptions(subscriptionId:\"".concat(subscriptionId, "\") {\n    list\n    email\n  }\n}");
};
var confirmationSubcriptionQuery = "query {\n  config {\n    newsletter {\n      seo {\n        title\n      }\n      immersiveText\n      immersiveBackground\n      confirmation {\n        headline\n        description\n      }\n      managementConfirmation {\n        headline\n        description\n      }\n    }\n    common {\n      goToHome\n    }\n  }\n}";

/***/ }),

/***/ "KGUB":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter/s",
      function () {
        return __webpack_require__("+lhU");
      }
    ]);
  

/***/ }),

/***/ "TnNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDataForSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitSubscriptionForm; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_without__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uUTq");
/* harmony import */ var lodash_without__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_without__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("jq/l");
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_omitBy__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("Nhxn");














function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





function filterObjectWithMapping(data) {
  var rules = {
    email: 'email',
    phone: 'phone',
    civility: 'gender',
    originCode: 'originCode',
    legalAgreement: 'legalAgreement',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions'
  };
  return Object.keys(data).reduce(function (result, currentAttribute) {
    var mappedField = rules[currentAttribute];

    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }

    return result;
  }, {});
}

var LIST_INPUTS = ['civility', 'firstName', 'lastName', 'email', 'originCode', 'phone', 'unicodeFirstName', 'unicodeLastName', 'privacyPolicyAggreement', 'legalAgreement'];
var formatDataForSubscription = function formatDataForSubscription(values) {
  var subscriptions = Object.keys(lodash_omitBy__WEBPACK_IMPORTED_MODULE_11___default()(values, function (value) {
    return value === false;
  }));
  return _objectSpread(_objectSpread({}, values), {}, {
    subscriptions: lodash_without__WEBPACK_IMPORTED_MODULE_10___default.a.apply(void 0, [subscriptions].concat(LIST_INPUTS))
  });
};
function submitSubscriptionForm(_ref) {
  var appContext = _ref.appContext,
      subscriptionId = _ref.subscriptionId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      isSubscription = _ref.isSubscription;
  var filteredData = filterObjectWithMapping(data);

  if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }

  filteredData.isSubscription = isSubscription;
  var selection = Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_15__[/* attributesToString */ "a"])(filteredData);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runNoCacheQuery("mutation RootMutationType {subscription (".concat(selection, ") { id neolaneId error { errorDescription }}}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* NEWSLETTER_SUBMIT_SUBSCRIPTION */ "qc"]
  });
}

/***/ }),

/***/ "p9RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onCheckboxChange; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lKOy");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_difference__WEBPACK_IMPORTED_MODULE_3__);




var CLUBMED = 'CLUBMED';
var PARTNERS = 'PARTNERS';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var FORYOUCLUB = 'FORYOUCLUB';
function onCheckboxChange(checkbox, setFieldValue) {
  var _fields;

  var fields = (_fields = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, CLUBMED, {
    checked: [CLUBMED],
    unchecked: [CLUBMED, PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, PARTNERS, {
    checked: [CLUBMED, PARTNERS],
    unchecked: [PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, FOSUN_PARTNERS, {
    checked: [FOSUN_PARTNERS],
    unchecked: [FOSUN_PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, FORYOUCLUB, {
    checked: [FORYOUCLUB],
    unchecked: [FORYOUCLUB]
  }), _fields);

  if (checkbox.checked) {
    lodash_difference__WEBPACK_IMPORTED_MODULE_3___default()(fields[checkbox.name].checked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, true);
    });
  } else {
    lodash_difference__WEBPACK_IMPORTED_MODULE_3___default()(fields[checkbox.name].unchecked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, false);
    });
  }
}

/***/ }),

/***/ "uUTq":
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__("X+YX"),
    baseRest = __webpack_require__("R3TX"),
    isArrayLikeObject = __webpack_require__("Ndl3");

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ })

},[["KGUB",4,1,2,5,0,7,6,8,9,10,13]]]);